import React from 'react'
import styled from 'styled-components'
import Head from 'next/head'
import { createResource, useResource } from '@/lib/i18n'
import dynamic from 'next/dynamic'
const Footer = dynamic(import('@/components/home/footer'))
const KPHead = dynamic(import('@/components/head'))
const TopNavigation = dynamic(import('@/components/top-navigation'))

export const resource = createResource({
  en: {
    description:
      'The Terms of Service made by Kredit Pintar are a form of agreement that is set out in the form of a legal agreement between the user and Kredit Pintar',
  },
  id: {
    description:
      'Persyaratan Layanan yang dibuat oleh Kredit Pintar merupakan bentuk kesepakatan yang dituangkan dalam bentuk perjanjian yang legal antara pengguna dan Kredit Pintar',
  },
})

export const termsOfService = () => {
  const { t } = useResource(resource)
  const styleContent = styleContentRaw
  return (
    <BannerBox>
      <KPHead metaTitle="termsOfService" />
      <Head>
        <meta name="description" content={t('description')} />
      </Head>
      <TopNavigation hideSwitch={true} />
      <div>
        <div dangerouslySetInnerHTML={{ __html: htmlContentRawId }}></div>
        <style dangerouslySetInnerHTML={{ __html: styleContent }}></style>
      </div>
      <Footer />
    </BannerBox>
  )
}
export default termsOfService

export const htmlContentRawId = `<div class="c8 doc-content">
  <p class="c5">
    <span class="c2">Ketentuan Penggunaan &ndash;</span><span class="c6 c4 c2">&nbsp;Terms of Use</span>
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c5"><span class="c2">1. Pengertian</span><span class="c4 c2 c6">&nbsp;&ndash; Definition </span></p>
  <p class="c1">
    <span>1.1.</span><span class="c2">&nbsp;&ldquo;Penerima Pinjaman&rdquo;</span
    ><span class="c0">&nbsp;berarti Penerima Dana sebagaimana didefinisikan dalam POJK 10.</span>
  </p>
  <p class="c1">
    <span class="c4 c2">&ldquo;Borrower&rdquo;</span
    ><span class="c3">&nbsp;means the Fund Recipient as defined in POJK 10. </span>
  </p>
  <p class="c1 c9"><span class="c0"></span></p>
  <p class="c1">
    <span>1.2</span
    ><span class="c2">. &ldquo;Perjanjian Pendanaan Bersama Uang Berbasis Teknologi Informasi&rdquo;</span
    ><span>&nbsp;atau </span><span class="c2">&ldquo;Perjanjian Pinjaman&rdquo; </span
    ><span class="c0"
      >berarti perjanjian antara Pemberi Pinjaman dan Penerima Pinjaman sehubungan dengan Pinjaman.</span
    >
  </p>
  <p class="c1">
    <span class="c4 c2">&ldquo;Lender Borrower Agreement&rdquo; </span><span class="c4">or</span
    ><span class="c4 c2">&nbsp;&ldquo;LBA&rdquo;</span
    ><span class="c3">&nbsp;means the agreement between the Lender and the Borrower in relation to the Loan.</span>
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span>1.3.</span><span class="c2">&nbsp;&ldquo;Pemberi Pinjaman&rdquo;</span
    ><span class="c0">&nbsp;berarti Pemberi Dana sebagaimana didefinisikan dalam POJK 10.</span>
  </p>
  <p class="c1">
    <span class="c4 c2">&ldquo;Lender&rdquo;</span
    ><span class="c3">&nbsp;means the Funder as defined in POJK 10.</span>
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span>1.4.</span><span class="c2">&nbsp;&ldquo;Pinjaman&rdquo;</span
    ><span class="c0"
      >&nbsp;berarti fasilitas pinjaman yang diterima oleh Penerima Pinjaman dari Pemberi Pinjaman melalui Platform
      Kami sesuai dengan Perjanjian Pinjaman.</span
    >
  </p>
  <p class="c1">
    <span class="c4 c2">&ldquo;Loan&rdquo;</span
    ><span class="c3"
      >&nbsp;means the loan facility obtained by the Borrower from the Lender through Our Platform in accordance with
      the Lender Borrower Agreement.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span>1.5. </span><span class="c2">&ldquo;Informasi Pribadi&rdquo;</span
    ><span class="c0"
      >&nbsp;berarti meliputi segala data, keterangan, informasi dan dokumen, baik elektronik maupun non-elektronik
      yang dapat mengidentifikasi seseorang, termasuk Kontak Terdaftar (sebagaimana didefinisikan dalam Kebijakan
      Privasi) dan informasi dari maupun sehubungan dengan Pengguna (baik Pemberi Pinjaman maupun Penerima Pinjaman,
      sesuai konteksnya) dan/atau pihak terkait dengan Pengguna (termasuk namun tidak terbatas pada keluarga, rekan,
      karyawan, perwakilan perusahaan atau penyedia jasa Pengguna, apabila dipersyaratkan) yang Kami terima atau akses
      dari Pengguna, diajukan, diberikan atau diungkapkan oleh Pengguna kepada Kami, berdasarkan persetujuan Pengguna
      serta disimpan dan dikelola sehubungan dengan penyediaan Layanan pada Platform, dan dalam rangka pemanfaatan
      Layanan pada Platform oleh Pengguna.</span
    >
  </p>
  <p class="c1">
    <span class="c4 c2">&ldquo;Personal Information&rdquo;</span
    ><span class="c3"
      >&nbsp;means all data, statements, information and documents, both in electronic and non-electronic form that
      may identify an individual, including the Registered Contact (as defined in the Privacy Policy) and information
      of or relevant to Users (both Borrowers and Lenders, according to the context) and/or any parties related to the
      User (including but not limited to family, colleagues, employees, representatives of companies or the
      User&rsquo;s service providers, if required) received or accessed by Us from the User, submitted, given or
      disclosed by the User to Us, according to the User&#39;s consent and stored and managed in connection with the
      provision of Services on the Platform, and in order to use the Services on the Platform by Users.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span>1.6. </span><span class="c2">&ldquo;Platform&rdquo; </span
    ><span class="c0"
      >berarti situs, aplikasi seluler, atau media digital terkait lainnya yang dimiliki oleh Kami sehubungan dengan
      penyediaan Layanan.</span
    >
  </p>
  <p class="c1">
    <span class="c4 c2">&ldquo;Platform&rdquo; </span
    ><span class="c3"
      >means the Kredit Pintar website, mobile application, or other related digital medium or media owned by Us in
      relation to the provision of Services.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span>1.7.</span><span class="c2">&nbsp;&ldquo;POJK 10&rdquo; </span
    ><span class="c0"
      >berarti Peraturan Otoritas Jasa Keuangan No. 10/POJK.05/2022 tentang Layanan Pendanaan Bersama Berbasis
      Teknologi Informasi.</span
    >
  </p>
  <p class="c1">
    <span class="c4 c2">&ldquo;POJK 10&rdquo;</span
    ><span class="c3"
      >&nbsp;means the Financial Services Authority (OJK) Regulation Number 10/POJK.05/2022 regarding Information
      Technology Based Joint Funding Services.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span>1.8. </span><span class="c2">&ldquo;Layanan&rdquo;</span
    ><span class="c0"
      >&nbsp;berarti penyediaan layanan oleh Kami melalui Platform, termasuk diantaranya adalah penyediaan Pinjaman
      kepada Penerima Pinjaman melalui Platform Kami.</span
    >
  </p>
  <p class="c1">
    <span class="c4 c2">&ldquo;Services&rdquo; </span
    ><span class="c3"
      >means the provision of services which is provided by Us through the Platform, amongst other things the
      provision of Loan to the Borrower through Our Platform.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span>1.9. </span><span class="c2">&ldquo;Pengguna&rdquo;</span
    ><span class="c0">&nbsp;berarti pihak yang menggunakan Layanan Kami.</span>
  </p>
  <p class="c1">
    <span class="c4 c2">&ldquo;User&rdquo; </span><span class="c4">or</span
    ><span class="c4 c2">&nbsp;&ldquo;Users&rdquo;</span
    ><span class="c3">&nbsp;(as the context may require) means any party that uses Our Services.</span>
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span>1.10.</span><span class="c2">&nbsp;&ldquo;Kami&rdquo;</span
    ><span class="c0"
      >&nbsp;berarti PT Kredit Pintar Indonesia, suatu perseroan terbatas yang didirikan berdasarkan hukum negara
      Republik Indonesia, yang menyediakan, mengelola, dan mengoperasikan LPBBTI secara konvensional.
    </span>
  </p>
  <p class="c1">
    <span class="c4 c2">&ldquo;We&rdquo;</span><span class="c4">&nbsp;or</span
    ><span class="c4 c2">&nbsp;&ldquo;Us&rdquo;</span><span class="c4">&nbsp;or</span
    ><span class="c4 c2">&nbsp;&ldquo;Our&rdquo;</span
    ><span class="c3"
      >&nbsp;(as the context may require) means PT Kredit Pintar Indonesia, a limited liability company established
      under the laws of the Republic of Indonesia, that provides, manage, and operates ITBJFS conventionally.
    </span>
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span>1.11.</span><span class="c2">&nbsp;&ldquo;Anda&rdquo; </span
    ><span class="c0">berarti Pengguna yang menggunakan Layanan Kami.</span>
  </p>
  <p class="c1">
    <span class="c4 c2">&ldquo;You&rdquo; </span><span>or</span><span class="c2">&nbsp;&ldquo;Your&rdquo; </span
    ><span class="c3">(as the context may require) means the User who uses Our Services.</span>
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span>1.12.</span><span class="c2">&nbsp;&ldquo;LPBBTI&rdquo; </span
    ><span class="c0"
      >berarti Layanan Pendanaan Bersama Berbasis Teknologi Informasi sebagaimana dimaksud pada POJK 10.
    </span>
  </p>
  <p class="c1">
    <span class="c4 c2">&ldquo;LPBBTI&rdquo; </span></span
    ><span class="c3">means Information Technology Based Joint Funding Services as referred to in POJK 10. </span>
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c5"><span class="c2">2. Umum</span><span class="c6 c4 c2">&nbsp;&ndash; General</span></p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0">
      2.1. Sebagai LPBBTI, Kami menyelenggarakan layanan jasa keuangan untuk mempertemukan Pemberi Pinjaman dengan 
      Penerima Pinjaman dalam melakukan Pinjaman konvensional secara langsung melalui Platform dengan menggunakan 
      internet.
    </span>
  </p>
  <p class="c1">
    <span class="c3">
      As ITBJFS, we provide financial services to connect the Lender and the Borrower in providing conventional Loan 
      directly via the Platform using the internet.
    </span>
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span
      >2.2. Ketentuan Penggunaan ini adalah perjanjian antara Pengguna dan Kami, yang berisi ketentuan-ketentuan yang
      mengatur mengenai hak, kewajiban, dan tanggung jawab Pengguna dan Kami dalam penggunaan Layanan Kami (</span
    ><span class="c2">&ldquo;Layanan Penggunaan&rdquo;</span><span class="c0">).</span>
  </p>
  <p class="c1">
    <span class="c4"
      >This Terms of Use shall be the agreement between the User and Us which contains a set provisions governing the
      rights, obligations and responsibilities of the User and Us in using Our Services (</span
    ><span class="c4 c2">&ldquo;Terms of Use&rdquo;</span><span class="c3">).</span>
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >2.3. Dengan menggunakan Layanan Kami, Anda mengakui bahwa Anda telah membaca, memahami, menerima, dan
      menyetujui Ketentuan Penggunaan ini dan oleh karenanya Anda telah setuju untuk diikat secara hukum oleh
      Ketentuan Penggunaan serta dokumen-dokumen lain sehubungan dengan Ketentuan Penggunaan ini. Apabila Anda tidak
      menyetujui Ketentuan Penggunaan ini, mohon untuk tidak menggunakan Layanan Kami.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >By using Our Service, You acknowledge that You have read, understood, accepted and agreed to these Terms of Use
      and as such You have agreed to be legally bound by these Terms of Use and other documents related to these Terms
      of Use. If You do not agree with these Terms of Use, please do not use Our Services.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >2.4. Layanan tidak untuk digunakan di luar negara atau yurisdiksi atau oleh orang yang dapat menjadikan
      penggunaannya melanggar hukum. Apabila Anda termasuk kategori ini, Anda tidak diperkenankan untuk mengakses atau
      menggunakan Layanan.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >The Service is not for use within any country or jurisdiction or by any persons where such use would constitute
      a violation of law. If this applies to You, You are not authorized to access or use the Service.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >2.5. Akses Anda ke dan penggunaan Layanan tunduk pada Ketentuan Penggunaan di bawah ini, termasuk juga semua
      peraturan perundang-undangan yang berlaku. Harap untuk membaca ketentuan-ketentuan ini dengan teliti. Apabila
      Anda tidak menyetujui dan tidak sepakat untuk terikat pada Ketentuan Penggunaan ini, Anda tidak diperkenankan
      untuk mengakses untuk dengan cara apapun menggunakan Layanan manapun. Akses Anda ke dan penggunaan Layanan
      merupakan kesepakatan Anda untuk mematuhi setiap Ketentuan Penggunaan sebagaimana diatur di bawah.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >Your access to and use of the Services are subject to the following Terms of Use, as well as all applicable
      laws and regulations. Please read these terms carefully. If You do not accept and agree to be bound by any of
      these Terms of Use, You are not authorized to access or otherwise use any Services. Your access to and use of
      the Services constitute Your acceptance of and agreement to abide by each of these Terms of Use as set forth
      below.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span>2.6.</span
    ><span class="c2"
      >&nbsp;Ketentuan Penggunaan ini dapat diubah, dimodifikasi, ditambah atau diperbaharui dari waktu ke waktu dengan
      pemberitahuan terlebih dahulu. </span
    ><span class="c0"
      >Kecuali dinyatakan sebaliknya, setiap Layanan tambahan akan juga tunduk pada Ketentuan Penggunaan ini yang
      berlaku secara efektif sejak tanggal penambahan tersebut.</span
    >
  </p>
  <p class="c1">
    <span class="c4 c2"
      >These Terms of Use may be changed, modified, supplemented or updated from time to time with advance
      notice.</span
    ><span class="c3"
      >&nbsp;Unless otherwise indicated, any additional Services will also be subject to these Terms of Use effective
      upon the date of any such addition.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >2.7. Kami dapat memberitahu Anda tentang perubahan yang dibuat pada Ketentuan Layanan ini melalui e-mail ke
      alamat e-mail terdaftar Anda, melalui Platform, ataupun metode lainnya yang Kami pandang diperlukan.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >We may notify You of changes made to these Terms of Use via e-mail to Your registered e-mail address, through
      the Platform, or any other method as we deem necessary.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >2.8. Dengan tetap menggunakan Layanan Kami, maka Anda menyetujui perubahan-perubahan dalam Ketentuan Layanan
      ini.</span
    >
  </p>
  <p class="c1">
    <span class="c3">By continuing to use Our Services, You agree to any changes to these Terms of Use.</span>
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >2.9. Dalam hal terdapat perbedaan apapun di antara Ketentuan Penggunaan ini dan media pemasaran manapun
      (termasuk namun tidak terbatas pada media daring), Ketentuan Penggunaan ini yang akan berlaku.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >If there are any inconsistencies between this Terms of Use with any marketing media (including but not limited
      to information from online media), this Terms of Use shall prevail.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >2.10. Layanan Kami dimaksudkan untuk digunakan oleh (i) Pengguna berumur setidaknya delapan belas (18) tahun dan
      memiliki kapasitas hukum untuk menjadi pihak dalam suatu perjanjian yang mengikat; atau (ii) badan hukum yang
      diwakili oleh perwakilan resmi dan memiliki kapasitas hukum untuk menjadi pihak dalam suatu perjanjian yang
      mengikat; khususnya penyediaan Layanan, dan berlokasi di area cakupan Kami. Setiap hal yang berkaitan dengan
      akses ke, atau penggunaan dari, Layanan dan/atau Platform diatur dan dibuat berdasarkan hukum Indonesia tanpa
      mempengaruhi prinsip hukum internasional manapun. Kegagalan untuk memenuhi syarat-syarat tersebut merupakan
      penggunaan yang tidak sah dan ilegal dari Layanan dan / atau akses ke Platform Kami.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >Our Services is intended to be used by (i) Users of at least eighteen (18) years of age and have the legal
      capacity to enter into binding agreements; or (ii) legal entity represented by duly authorized representative
      and has the legal capacity to enter into binding agreements; specifically the provision Services, and located
      within Our coverage area. All matters relating to access to, or use of, the Services and/or Platform are
      governed and constructed in accordance with Indonesian law without affecting any principle of international
      law.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >2.11. Untuk berpartisipasi dalam penyediaan atau untuk mendapatkan Layanan melalui Platform, Anda diwajibkan
      untuk membuat akun dan mendaftarkan diri Anda di Platform serta memenuhi proses pendaftaran sebagai Pengguna
      terdaftar.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >To participate in providing or obtaining the Services via the Platform, You are required to make an account and
      register yourself in the Platform and complete the registration process as a registered User.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >2.12. Dengan mendaftarkan diri Anda di Platform Kami, Anda dengan ini menyatakan bahwa Anda telah membaca,
      memahami, dan menyepakati Ketentuan Penggunaan ini serta ketentuan kerahasiaan yang berlaku untuk Platform
      ini.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >By registering Yourself in Our Platform, You hereby declare that You have already read, understood, and agree
      to this Terms of Use as well as the privacy policy applicable to this Platform.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >2.13. Anda diwajibkan untuk menyediakan kepada Kami Informasi Pribadi yang benar, akurat, lengkap. Anda
      menjamin bahwa tidak ada informasi yang menyesatkan dan/atau tidak relevan yang disediakan kepada Kami pada saat
      proses pendaftaran dan proses-proses selanjutnya yang berkaitan dengan penggunaan Platform. Anda diwajibkan
      untuk memberitahu Kami atas setiap perbaruan atau perubahan terhadap Informasi Pribadi.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >You are required to provide Us with true, accurate, complete and valid Personal Information. You guarantee that
      there is no misleading and/or irrelevant information being provided to Us during the registration process and
      any other stage in the use of the Platform. You are required to notify Us of any updates to any changes to
      Personal Information.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0">
      2.14. Kegiatan usaha Kami sebagai LPBBTI tunduk kepada seluruh ketentuan peraturan perundang-undangan yang terkait 
      dengan LPBBTI.
    </span>
  </p>
  <p class="c1">
    <span class="c3">
      Our business activities as ITBJFS are subject to all applicable laws and regulations relating to ITBJFS.
    </span>
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c2">3. Layanan Pendanaan Uang Berbasis Teknologi Informasi</span
    ><span class="c6 c4 c2">&nbsp;&ndash; Information Technology Based Joint Funding Services</span>
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0">
      3.1. Sebelum mengajukan permohonan Pinjaman, Anda harus memahami transaksi dan isi perjanjian Pinjaman, termasuk 
      bahwa batas atas fasilitas Pinjaman disesuaikan dengan kemampuan Anda dalam melakukan transaksi.
    </span>
  </p>
  <p class="c1">
    <span class="c3">
      Before applying for a Loan, You must understand the transaction and the contents of the Loan Agreement, including 
      that the limit of the Loan is adjusted to your ability to carry out the transaction.
    </span>
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >3.2. Kami akan memproses formular permohonan Pinjaman yang telah diajukan dengan semua informasi Anda, data
      Anda, dan dokumen-dokumen pendukung yang dibutuhkan. Kami berhak dan memiliki kebijaksanaan yang mutlak untuk
      menyetujui atau menolak permohonan Anda. Penolakan atau persetujuan atas permohonan Pinjaman akan diinformasikan
      melalui Platform.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >We will process the Loan application form which has been filled with all Your information, data, and supporting
      documents required. We have the rights and absolute discretion to accept or reject Your application. Rejection
      or acceptance of Loan application will be informed through the Platform.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >3.3. Untuk Pinjaman yang telah disetujui, termasuk jumlah dan periode pembayaran kembali, akan dicairkan dengan
      cara mengkreditkan jumlah tersebut ke rekening Penerima Pinjaman dan/atau rekening lain yang disetujui oleh
      Penerima Pinjaman yang telah didaftarkan di Platform Kami. Penerima Pinjaman bertanggung jawab atas ketepatan
      data rekening bank yang diberikan kepada Kami. Kami tidak akan bertanggung jawab terhadap setiap kerugian,
      klaim, dan/atau gugatan hukum dalam bentuk apapun terhadap atau dari Penerima Pinjaman atau pihak lain yang
      disebabkan oleh kesalahan, ketidaktepatan, dan/atau informasi palsu atas rekening bank yang disediakan kepada
      Kami.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >For the Loan which has been approved, including the amount and the repayment period, such will be disbursed by
      crediting the amount to Borrower&rsquo;s account and/or other account agreed by the Borrower, which has been
      registered on Our Platform. The Borrower is responsible for the accuracy of the bank account data given to Us.
      We will not be responsible for any loss, claims, and/or lawsuits in any form whatsoever to or by the Borrower or
      any other party due to such mistake, inaccurate, and/or false bank account provided to Us.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >3.4. Setelah permohonan Pinjaman disepakati, Pinjaman tunduk pada hak dan kewajiban berdasarkan kontrak
      dan/atau perjanjian tertentu antara Penerima Pinjaman dan Pemberi Pinjaman yang akan ditandatangani kemudian.
      Dalam hal ini, kami tidak menjamin atau berjanji bahwa (a) Penerima Pinjaman akan mendapatkan Pinjaman yang
      diusulkan atau bahwa (b) Pemberi Pinjaman akan mendapatkan pembayaran penuh dari Pinjaman yang disediakan. Untuk
      menghindari keraguan, segala resiko yang ditimbulkan dari dan/atau disebabkan oleh Perjanjian Pinjaman akan
      ditanggung oleh pihak terkait, baik Pemberi Pinjaman atau Penerima Pinjaman, dan kedua pihak dengan ini
      melepaskan, membebaskan dan mengganti kerugian Kami atas segala hal yang disebabkan dan/atau timbul karena untuk
      kesepakatan tersebut.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >Upon the acceptance of the Loan application, the Loan is subject to rights and obligations under certain
      contracts and/or agreement between the Borrower and Lender that will be entered subsequently. In this case, we
      neither guarantee nor undertake that (a) the Borrower will obtain the proposed Loan nor that (b) the Lender will
      obtain full repayment of the provided Loan. In avoidance of doubt, any risk resulted and/or caused by the LBA
      shall be borne by the relevant party, either the Lender or Borrower, and that both party hereby release, hold
      harmless and indemnify Us for any matters caused and/or raised due to such agreement.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >3.5. Penerima Pinjaman diwajibkan untuk membayar kembali Pinjaman berdasarkan periode pembayaran kembali yang
      diatur dalam Perjanjian Pinjaman. Periode Pinjaman dimulai dari tanggal pencairan Pinjaman ke rekening bank
      Penerima Pinjaman dan/atau rekening lain yang disetujui oleh Penerima Pinjaman yang terdaftar di Platform.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >The Borrower is obliged to repay the Loan based on the agreed repayment period within the LBA. The Loan period
      starts from the day Loan is disbursed into the Borrower&rsquo;s registered bank account and/or other account
      agreed by the Borrower in the Platform.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >3.6. Penerima Pinjaman akan membayar kembali Pinjaman dengan biaya lain (sebagaimana diinformasikan secara
      transparan dalam Platform) ke rekening penampungan atau rekening virtual yang kami buka untuk tujuan pembayaran
      kembali Pinjaman oleh Penerima Pinjaman, dan Kami akan membayar Pemberi Pinjaman melalui rekening penampungan
      yang dibuka oleh Kami dan Pemberi Pinjaman untuk tujuan menerima pembayaran kembali atas Pinjaman
      tersebut.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >The Borrower shall repay the Loan with other fees (as informed transparently in the Platform) to the
      escrow/virtual account opened by Us for the purpose of repayment of the Loan by the Borrower, and We will
      further pay the Lender through the escrow account opened by Us and the Lender for the purpose of receiving such
      repayment of the Loan.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >3.7. Pembayaran kembali atas Pinjaman dan biaya-biaya lain (apabila ada) dapat dilakukan melalui:</span
    >
  </p>
  <p class="c1"><span class="c3">Repayment of the Loan and other fees (if any) can be done through:</span></p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >a. ATM dengan transfer dana ke rekening bank yang ditentukan dan dijelaskan di Platform dari waktu ke
      waktu;</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >ATM by transfer to the bank account as determined and described in the Platform from time to time;</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >b. E-Banking dengan transfer dana ke rekening bank yang ditentukan dan dijelaskan di Platform dari waktu ke
      waktu;</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >E-Banking by transfer to the bank account as determined and described in the Platform from time to time;
      or</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >c. cara-cara lain sebagaimana dapat ditentukan oleh Kami yang dapat kami informasikan sebelum Pinjaman
      diberikan, sesuai dengan ketentuan peraturan perundang-undangan yang berlaku.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >Any other method as may be determined by Us that may be informed in advance of the Loan being granted, in
      accordance with the prevailing rules and regulations.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >3.8. Anda hanya diperbolehkan untuk mengakses dan/atau menggunakan Platform untuk penggunaan Anda sendiri, yang
      berarti bahwa Platform hanya dapat diakses dan digunakan secara langsung oleh individu atau entitas yang mencari
      Layanan untuk individu atau entitas itu sendiri.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >You are only allowed to access and/or use the Platform for Your own use, which means that the Platform can only
      be accessed and used directly by individual or entity which is seeking the Services for the individual or entity
      itself.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >3.9. Segala risiko kesalahpahaman, miskomunikasi, kesalahan, kerusakan, biaya atau kerugian yang ditimbulkan
      oleh penggunaan Platform atau sehubungan dengan Perjanjian Pinjaman sepenuhnya menjadi risiko Anda sendiri. Kami
      tidak bertanggung jawab atas kerugian yang disebabkan oleh kegagalan dalam mengakses Platform dan metode
      penggunaan Platform yang berada di luar kendali Kami atau melanggar Ketentuan Penggunaan ini.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >Any risk of misunderstanding, miscommunications, errors, damages, costs or losses incurred by the use of the
      Platform or in connection with LBA is entirely at your own risk. We are not responsible for any loss caused by a
      failure in accessing Platform and Platform usage method that is beyond Our control or in breach of this Terms of
      Usage.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >3.10. Kami tidak berkewajiban untuk menyetujui permohonan Pinjaman yang diajukan oleh Anda melalui Platform.
      Kami berhak untuk tidak memproses permohonan Anda yang tidak memenuhi persyaratan atau tidak memberikan
      Informasi Pribadi yang akurat dan/atau valid. Selain itu, kami berhak untuk mencabut permohonan Pinjaman Anda
      dari waktu ke waktu, atas kecurigaan atau indikasi adanya pelanggaran dan/atau pelanggaran terhadap Ketentuan
      Penggunaan ini.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >We are not obliged to approve Loan applications submitted through the Platform by You. We reserve rights to not
      process your application which does not meet the requirements or does not provide with accurate and/or valid
      Personal Data. Additionally, we reserve the rights to revoke your Loan application from time to time, upon
      suspicion or indication of violation and/or violation of this Terms of Use.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >3.11. Dengan mengirimkan informasi kontak Anda, Anda setuju untuk dihubungi oleh Kami termasuk namun tidak
      terbatas pada telepon, pesan teks, dan metode komunikasi lain yang memungkinkan komunikasi terkait Pinjaman
      dan/atau permohonan Pinjaman Anda. Selanjutnya, Anda dengan ini menjamin bahwa Anda telah menerima persetujuan
      dari pihak yang Anda daftarkan untuk menjadi kontak darurat Anda di Platform kami. Anda dengan ini melepaskan
      dan akan memberikan ganti rugi kepada kami atas kerugian, klaim, atau gugatan hukum kepada Kami sehubungan
      dengan percobaan untuk atau berkomunikasi dengan kontak darurat yang Anda daftarkan di Platform kami.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >By sending Your contact information, You agree to be contacted by Us including but not limited to phone, text
      message, and other communication methods that allow communication regarding Your Loan and/or Loan application.
      Furthermore, You hereby warrant that You have received the consent of the party in which You register to be Your
      emergency contact in our Platform. You hereby release and indemnify us for any loss, claims, or lawsuits for Us
      attempting to or communicating with such emergency contact in which You registered in our Platform.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1"><span class="c0">3.12. Dengan mendaftar pada Platform Kami, Anda dengan ini menjamin bahwa:</span></p>
  <p class="c1"><span class="c3">By registering to Our Platform, You hereby warrant that:</span></p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >a. Setiap informasi yang Anda berikan kepada Kami adalah benar, akurat, lengkap, dan tidak menyesatkan;</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >Every information that You deliver to Us is correct, accurate, and complete, and not misleading;</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >b. Anda tidak gagal untuk membayar/wanprestasi atau dinyatakan gagal bayar/wanprestasi oleh pihak ketiga
      lainnya;</span
    >
  </p>
  <p class="c1"><span class="c3">You are not in default or declared in default by other third parties;</span></p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >c. Anda akan menggunakan Pinjaman sesuai dengan rencana penggunaan sebagaimana dinyatakan dalam permohonan
      Pinjaman Anda;</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >You will utilize the Loan in correspondence with the utilization plan as stated in Your Loan application;</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >d. Anda sepenuhnya bertanggung jawab atas Pinjaman dan semua konsekuensi hukum yang timbul karenanya; dan</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >Your are fully responsible for the Loan and all legal consequences which comes with it; and</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >e. Anda tidak akan melakukan apapun yang dapat membatasi atau mengurangi hak-hak Kami sebagaimana diatur dalam
      Ketentuan Penggunaan ini.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >You will not do anything that can cause limitation or reduction of Our rights stipulated in this Terms of
      Use.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >3.13. Anda dengan ini memberikan wewenang kepada Kami untuk memberikan pemberitahuan atau informasi apa pun
      kepada Pemberi Pinjaman atau Penerima Pinjaman (sebagaimana berlaku) sehubungan dengan Anda untuk mendapatkan
      Layanan. Oleh karena itu, Anda mengakui bahwa pengiriman setiap pemberitahuan, informasi, permintaan, pesanan,
      peringatan, permintaan, dengan cara apapun, oleh Kami, afiliasi Kami, atau subkontraktor Kami sebagai pengiriman
      yang sah serta pemberitahuan, informasi, permintaan, pesanan, peringatan, yang sah, sehubungan dengan pengadaan
      Layanan Anda.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >You hereby authorize Us to provide any notice or information to the Lender or Borrower (as applicable) with
      regards to You procuring the Services. You therefore acknowledge the delivery of any notice, information,
      request, order, warning, demand, in any manner whatsoever, by Us, Our affiliates, or any of Our subcontractors
      as a valid delivery and valid notice, information, request, order, warning, demand with regards to your
      procurement of the Services.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0">
      3.14. Dalam hal terjadi wanprestasi atas Pinjaman yang dilakukan oleh Anda, maka ketentuan perihal konsekuensi 
      dari cidera janji maupun segala ketentuan terkait lainnya sebagaimana diatur dalam Perjanjian Pinjaman akan 
      berlaku, dan kami dapat menginformasikan prosedur penyelesaian dan penagihan lebih lanjut kepada Pemberi 
      Pinjaman dan Anda.
    </span>
  </p>
  <p class="c1">
    <span class="c3">
      In the event of a default on the Loan by You, the provisions regarding consequences of event of default within 
      the LBA as well as any other relevant provision shall be applicable, and we may further inform the Lender and 
      You about the resolution and collection procedures.
    </span>
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c5">
    <span class="c2">4. Hak Kekayaan Intelektual</span
    ><span class="c6 c4 c2">&nbsp;&ndash; Intellectual Property Rights</span>
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >4.1. Kekayaan Intelektual Kami, termasuk namun tidak terbatas pada hak cipta, paten dan merek untuk dan atas
      nama Kami sepenuhnya dimiliki dan menjadi aset tetap Kami. Anda harus menganggap bahwa semua yang Anda baca atau
      lihat sehubungan dengan penggunaan Layanan Kami oleh Anda adalah hak kekayaan intelektual Kami, atau suatu pihak
      ketiga yang melisensikan hak penggunaan kekayaan intelektual tersebut kepada Kami. Kecuali selain yang
      disebutkan secara jelas, semua yang Anda baca atau lihat sehubungan dengan penggunaan Layanan Kami oleh Anda
      atau setiap source code atau kode HTML yang Kami gunakan untuk menghasilkan Layanan, tidak diperbolehkan untuk
      disalin, direproduksi, dimodifikasi, didistribusikan, ditransmisikan, diterbitkan ulang, ditampilkan, atau
      digunakan secara komersial tanpa persetujuan tertulis sebelumya ole Kami, kecuali sebagaimana diatur dalam
      Ketentuan Layanan ini, kecuali diperbolehkan oleh ketentuan perundang-undangan yang berlaku.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >Our intellectual property rights, including but not limited to copyrights, patents and trademarks for and on
      behalf of Us are wholly owned by and become Our fixed asset. You shall assume that everything You read or see in
      relation to Your use of Our Service are Our intellectual property rights, or a third party who licensed the
      right or has given consent to Us for the use of such intellectual property. Unless otherwise expressly noted,
      nothing that You read or see in relation to Your use of Our Service or any of the source code or HTML code that
      We use to generate the Service may be copied, reproduced, modified, distributed, transmitted, republished,
      displayed, or performed for commercial use without Our prior written consent, except permitted by the applicable
      laws and regulations.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >4.2. Anda diperkenankan untuk melihat dan menyalin atau mencetak kertas konten yang disediakan oleh Layanan
      Kami, namun:</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >You are permitted to view and copy-print on the content paper provided by Our Service, however:</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >a. semua Salinan adalah hak kekayaan intelektual Kami dan para pihak ketiga yang telah Kami berikan lisensi;
      dan</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >all copies are the intellectual property rights of Us and third parties to whom We grant licenses; and</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >b. Anda tidak mengubah, dengan cara apapun, salinan kertas dari bahan cetak, termasuk penghapusan setiap hak
      cipta atau hak kepemilikan lainnya yang terkadung dalam Layanan Kami.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >You do not alter in any way a copy of the paper from printed materials, including the deletion of any copyright
      or other proprietary rights contained in the Our Service.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >4.3. Kami berhak untuk mengambil tindakan hukum apapun yang dianggap tepat sebagai tanggapan atas pelanggaran
      atau dugaan pelanggaran hal-hal di atas, termasuk namun tidak terbatas pada penangguhan atau pengakhiran akses
      dan/atau akun Pengguna. Kami dapat bekerja sama dengan otoritas hukum dan/atau pihak ketiga dalam penyelidikan
      dugaan kejahatan atau pelanggaran sipil. Kecuali sebagaimana mungkin dibatasi secara tegas oleh Kebijakan
      Privasi, Kami setiap saat berhak untuk mengungkapkan setiap informasi yang Kami anggap perlu untuk mematuhi
      hukum, peraturan, proses hukum atau permintaan pemerintah apapun, atau untuk menyunting, menolak untuk mengirim
      atau untuk menghapus informasi atau materi apapun, secara sebagian atau seluruhnya, berdasarkan kebijaksanaan
      Kami.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >We reserve the right to take whatever lawful actions it may deem appropriate in response to actual or suspected
      violations of the foregoing, including but not limited to the suspension or termination of the User&#39;s access
      and/or account. We may cooperate with legal authorities and/or third parties in the investigation of any
      suspected or alleged crime or civil wrong. Except as may be expressly limited by the Privacy Policy, We reserve
      the right at all times to disclose any information We deem necessary to satisfy any applicable law, regulation,
      legal process or governmental request, or to edit, refuse to post or to remove any information or materials, in
      whole or in part, based on Our sole discretion.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c5">
    <span class="c2">5. Aktivitas Yang Dilarang</span
    ><span class="c6 c4 c2">&nbsp;&ndash; Prohibited Activities</span>
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span>5.1. </span><span class="c2">Penggunaan yang Dilarang</span
    ><span class="c0"
      >&nbsp;&ndash; Hal-hal berikut ini dilarang: setiap penggunaan atau percobaan penggunaan Layanan (i) untuk
      tujuan yang melanggar hukum, tidak sah, curang atau jahat, atau (ii) yang dapat merusak, menghalangi, membebani,
      atau merusak server apapun, atau jaringan(-jaringan) yang terhubung dengan server, atau (iii) mengganggu
      penggunaan dan kenikmatan Layanan pihak lain manapun, atau (iv) untuk mendapatkan akses yang tidak sah ke akun,
      sistem komputer atau jaringan-jaringan lainnya yang terhubung dengan server atau sistem melalui peretasan,
      password mining atau dengan cara lainnya, (v) untuk mengakses sistem, data atau informasi yang tidak dimaksudkan
      Kami untuk dapat diakses Pengguna, atau (vi) untuk mendapatkan setiap materi atau informasi melalui cara apapun
      yang tidak sengaja Kami sediakan, atau (vii) untuk penggunaan lain apapun selain tujuan bisnis yang
      dimaksudkan.</span
    >
  </p>
  <p class="c1">
    <span class="c4 c2">Prohibited Use</span
    ><span class="c3"
      >&nbsp;&ndash; The following is prohibited: any use or attempted use of the Services (i) for any unlawful,
      unauthorized, fraudulent or malicious purpose, or (ii) that could damage, disable, overburden, or impair any
      server, or the network(s) connected to any server, or (iii) to interfere with any other party&#39;s use and
      enjoyment of the Services, or (iv) to gain unauthorized access to any other accounts, computer systems or
      networks connected to any server or systems through hacking, password mining or any other means, or (v) to
      access systems, data or information not intended by Us to be made accessible to a User, or (vi) to obtain any
      materials or information through any means not intentionally made available by Us, or (vii) for any use other
      than the business purpose for which it was intended.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0">5.2. Anda setuju untuk tidak menggunakan setiap bagian dari Layanan Kami untuk:</span>
  </p>
  <p class="c1"><span class="c3">You agree not to use any portion of Our Service to:</span></p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >a. memasukkan atau secara sengaja maupun tidak sengaja mentransmisikan virus, worms, trojan horses, time bombs,
      trap door, kode komputers, file atau program atau membuat permintaan berulang yang dirancang untuk mengganggu,
      merusak, atau membatasi fungsi perangkat lunak, perangkat keras computer, peralatan komunikasi, atau untuk
      mengurangi kualitas, mengganggu penampilan dari, atau merusak fungsionalitas Layanan Kami;</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >insertor intentionally or unintentionally transmit viruses, worms, trojan horses, time bombs, trap
      door, computer code, files or programs or making repeated requests designed to interfere with, impair or limit
      the functionality of the software, computer hardware, telecommunications equipment, or to reduce the quality,
      disrupt the appearance of, or damage the functionality of Our Service;</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >b. mengunggah, melakukan posting, mengirim e-mail atau menerima atau menempelkan tautan ke konten apapun yang
      memfasilitasi peretasan data;</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >upload, post, e-mail or otherwise accept, or paste links to any content facilitating data hacking;</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1"><span class="c0">c. meretas ke bagian manapun dari Layanan Kami;</span></p>
  <p class="c1"><span class="c3">hack into any part of Our Service;</span></p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >d. mengunggah, mengirimkan e-mail, atau mengirimkan tautan ke konten apapun yang melanggar hak kekayaan
      intelektual pihak ketiga;</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >upload, transmit e-mails, or transmit links to any content that infringes the intellectual property rights of
      third parties;</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >e. mengelak atau berusaha mengelak, perlindungan dari Layanan Kami; mengizinkan pihak ketiga manapun untuk
      melakukan hal-hal di atas;</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >circumvent or attempt to circumvent, any safeguards from Our Service; allow any third party to do all of the
      above;</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >f. mengubah nama, memodifikasi, atau membagikan ulang konten yang tersedia dalam Layanan Kami tanpa izin
      terlebih dahulu dari Kami.</span
    >
  </p>
  <p class="c1">
    <span class="c3">rename, modify, or reshare the content provided in Our Service without Our prior consent.</span>
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >g. menggugah atau mentransmisikan pesan, informasi, data, teks, peranti lunak atau gambar, atau konten-konten
      lainnya (&ldquo;Materi&rdquo;) yang melanggar hukum. berbahaya, mengancam, kasar, melecehkan, melawan hukum,
      memfitnah, vulgar, cabul, mencemarkan nama baik, atau tidak menyenangkan, atau yang mungkin dapat melanggar hak
      privasi atau publisitas pihak lain;</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >upload or transmit any message, information, data, text, software or images, or other content
      (&quot;Material&quot;) that is unlawful, harmful, threatening, abusive, harassing, tortious, defamatory, vulgar,
      obscene, libelous, or otherwise objectionable, or that may invade another&#39;s right of privacy or
      publicity;</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >h. menciptakan sebuah identitas palsu untuk tujuan menyesatkan orang lain atau meniru orang atau pihak manapun,
      termasuk namun tidak terbatas pada representatif Kami, atau secara salah menyatakan atau dengan salah
      menggambarkan afiliasi Anda dengan seseorang atau suatu pihak;</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >create a false identity for the purpose of misleading others or impersonate any person or entity, including but
      not limited to Our representative, or falsely state or otherwise misrepresent Your affiliation with a person or
      entity;</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >i. mengunggah atau mentransmisikan Materi manapun yang mana Anda tidak memiliki hak untuk memproduksi kembali,
      menampilkan, mentransmisikan berdasarkan hukum manapun atau berdasarkan hubungan kontraktual dan fidusia
      (seperti perjanjian kerahasiaan);</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >upload or transmit any Material that You do not have a right to reproduce, display or transmit under any law or
      under contractual or fiduciary relationships (such as non-disclosure agreements);</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >j. menggugah atau mendatangkan file yang mengandung virus, trojan horses, worms, time bombs, cancel-bots,
      corrupted files, atau peranti lunak lainnya atau program-program yang dapat merusak operasi komputer atau
      properti pihak lain;</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >upload or introduce files that contain viruses, trojan horses, worms, time bombs, cancel-bots, corrupted files,
      or any other similar software or programs that may damage the operation of another&#39;s computer or property of
      another;</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >k. menghapus atribusi penulis, pemberitahuan hukum atau penunjukan kepemilikan atau label yang Anda unggah ke
      setiap fitur komunikasi;</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >delete any author attributions, legal notices or proprietary designations or labels that You upload to any
      communication feature;</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >l. menggunakan fitur komunikasi dengan cara yang dapat berdampak buruk terhadap keterbatasan sumber dayanya
      kepada Pengguna lainnya (sebagai contoh, shouting secara berlebihan, penggunaan huruf besar (caps lock) yang
      berlebihan, atau memposting teks yang sama secara berulang);</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >use the communication features in a manner that adversely affects the availability of its resources to other
      Users (e.g., excessive shouting, use of all caps, or flooding continuous posting of repetitive text);</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >m. menggugah atau mentransmisikan iklan-iklan yang tidak diminta, materi promosi, junk mail, spam, chain
      letters, pyramid schemes atau segala bentuk ajakan, iklan lainnya, atau &nbsp;semacamnya;</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >upload or transmit any unsolicited advertising, promotional materials, &quot;junk mail,&quot; &quot;spam,&quot;
      &quot;chain letters,&quot; &quot;pyramid schemes&quot; or any other form of solicitation, commercial or
      otherwise;</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0">n. melanggar hukum internasional, negara, negara bagian atau daerah apapun;</span>
  </p>
  <p class="c1"><span class="c3">violate any applicable local, state, national or international law;</span></p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >o. menggugah atau mentransmisikan Materi apapun yang melanggar paten, merek dagang, merek jasa, rahasia dagang,
      hak cipta atau hak kepemilikan lainnya dari pihak manapun;</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >upload or transmit any Material that infringes any patent, trademark, service mark, trade secret, copyright or
      other proprietary rights of any party;</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0">p. menghapus atau merevisi setiap Materi yang diposting oleh orang atau pihak lain;</span>
  </p>
  <p class="c1"><span class="c3">delete or revise any Material posted by any other person or entity;</span></p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >q. memanipulasikan atau dengan cara lain menampilkan Layanan menggunakan framing, mirroring, atau teknologi
      navigasi serupa atau secara langsung menghubungkan bagian manapun dari Layanan selain dari Platform utama,
      sesuai dengan lisensi dan akses Layanan terbatas sebagaimana dijabarkan di atas;</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >manipulate or otherwise display the Services by using framing, mirroring or similar navigational technology or
      directly link to any portion of the Services other than the main Platform, in accordance with the limited
      license and Services access as outlined above;</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >r. mendaftarkan, melanggani, mencoba mendaftarkan, mencoba melanggani, tidak melanggani, atau mencoba untuk
      tidak melanggani, pihak manapun untuk Layanan manapun apabila Anda tidak secara tegas diizinkan oleh pihak
      tersebut untuk melakukan hal itu; atau</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >register, subscribe, attempt to register, attempt to subscribe, unsubscribe, or attempt to unsubscribe, any
      party for any Service if You are not expressly authorized by such party to do so; or</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >s. mengambil atau dengan cara apapun mengumpulkan informasi pihak lain, termasuk alamat e-mail.</span
    >
  </p>
  <p class="c1">
    <span class="c3">harvest or otherwise collect information about others, including e-mail addresses.</span>
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c5"><span class="c2">6. Keamanan</span><span class="c6 c4 c2">&nbsp;&ndash; Security</span></p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span>6.1.</span><span class="c2">&nbsp;Keamanan, Kata Sandi, Kata Sandi Akun</span
    ><span class="c0"
      >&nbsp;&ndash; Apabila Anda telah diberikan pilihan untuk membuka sebuah akun yang akan memberi Anda akses ke
      bagian situs yang dilindungi kata sandi dan Anda memilih untuk melakukannya, Anda harus menyelesaikan proses
      pendaftaran dengan memberikan Kami informasi yang terbaru, terlengkap, dan akurat sebagaimana diminta oleh
      formulir pendaftaran yang berlaku, dan memilih sebuah kata sandi dan nama pengguna. Anda sepenuhnya bertanggung
      jawab untuk menjaga kerahasiaan kata sandi dan akun Anda dan untuk setiap aktivitas yang terjadi pada akun Anda.
      Anda setuju untuk (a) segera memberitahu Kami atas segala penggunaan akun Anda yang tidak sah atau pelanggaran
      keamanan lainnya yang Anda ketahui, dan (b) keluar sepenuhnya dari Akun Anda pada setiap akhir sesi online. Kami
      tidak akan bertanggung jawab atas setiap kerugian yang mungkin Anda alami akibat penggunaan kata sandi atau
      akun, baik dengan sepengetahuan atau tanpa sepengetahuan Anda. oleh orang lain. Anda dapat bertanggung jawab
      atas segala kerugian yang Kami atau pihak lain alami sebagai akibat dari penggunaan akun atau kata sandi milik
      Anda oleh orang lain. Anda tidak diperbolehkan untuk menggunakan akun orang lain, baik dengan sepengetahuan atau
      tanpa sepengetahuan pemilik akun.</span
    >
  </p>
  <p class="c1">
    <span class="c4 c2">Password Accounts, Passwords, and Security</span
    ><span class="c3"
      >&nbsp;&ndash; If You have been given the option to open an account which will provide You with access to
      password protected portions of the Platform and You elect to do so, You must complete the registration process
      by providing Us with current, complete and accurate information as prompted by the applicable registration form,
      and choose a password and user name. You are entirely responsible for maintaining the confidentiality of Your
      password and account and for any and all activities that occur under Your account. You agree to (a) immediately
      notify Us of any unauthorized use of Your account or any other breach of security of which You become aware, and
      (b) exit completely from Your account at the end of each online session. We will not be liable for any loss that
      You may incur as a result of someone else using Your password or account, either with or without Your knowledge.
      However, You could be held liable for losses incurred by Us or another party due to someone else using Your
      account or password. You may not use anyone else&#39;s account at any time, with or without the permission of
      the account holder.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span>6.2. </span><span class="c2">Hak untuk Mengawasi</span
    ><span class="c0"
      >&nbsp;&ndash; Kami berhak untuk mengawasi penggunaan Layanan setiap waktunya sebagaimana Kami anggap patut dan
      untuk menghapus materi apapun yang, berdasarkan kebijaksanaan Kami, mungkin melanggar hukum, atau dapat
      menyebabkan Kami untuk bertanggung jawab, dapat melanggar Ketentuan Layanan ini, atau atas kebijaksanaan Kami,
      tidak konsisten dengan tujuan Kami untuk Layanan.</span
    >
  </p>
  <p class="c1">
    <span class="c4 c2">Right to Monitor </span
    ><span class="c3"
      >&ndash; We reserve the right to monitor the use of Services at any time as it deems appropriate and to remove
      any materials that, in Our sole discretion, may be illegal, may subject Us to liability, may violate these Terms
      of Use, or are, in Our sole discretion, inconsistent with Our purpose for the Services.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span>6.3. </span><span class="c2">Modifikasi Layanan</span
    ><span class="c0"
      >&nbsp;&ndash; Kami dapat, berdasarkan kebijaksanaan Kami, memodifikasi atau memberhentikan Layanan manapun atau
      bagian manapun dari Layanan tersebut, dengan atau tanpa pemberitahuan. Kami dan afiliasi Kami tidak akan
      bertanggung jawab terhadap Anda atau pihak lainnya atas modifikasi atau penghentian apapun atas Layanan.</span
    >
  </p>
  <p class="c1">
    <span class="c4 c2">Modification of Services</span
    ><span class="c3"
      >&nbsp;&ndash; To the extent as permitted by the prevailing laws and regulations, We may, at Our sole
      discretion, modify or discontinue any of the Services or any portion thereof, with or without notice. Neither Us
      nor Our affiliates will be liable to You or any third party for any modification or discontinuance of any of the
      Services.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span>6.4. </span><span class="c2">Kebijakan Privasi</span
    ><span class="c0"
      >&nbsp;&ndash; Kebijakan Privasi Kami menjelaskan pengumpulan, penggunaan dan perlindungan informasi pribadi
      non-publik dan akan membantu Anda untuk memahami bagaimana Kami menjaga dan memperlakukan informasi yang Kami
      terima. Kami menghimbau Anda untuk membaca Kebijakan Privasi Kami.</span
    >
  </p>
  <p class="c1">
    <span class="c4 c2">Privacy Policy</span
    ><span class="c3"
      >&nbsp;&ndash; Our Privacy Policy describes company collection, use and protection of non-public personal
      information and will help You understand how We secure and treat information that We obtain. We urge You to read
      Our Privacy Policy.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c5">
    <span class="c2">7. Ganti Rugi</span><span>&nbsp;&ndash;</span><span class="c4">&nbsp;</span
    ><span class="c6 c4 c2">Indemnity</span>
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >7.1. PENGGUNAAN LAYANAN OLEH ANDA ADALAH RISIKO ANDA SEORANG, SEMUA KONTEN DAN PERANTI LUNAK DISEDIAKAN
      BERDASARKAN &ldquo;SEBAGAIMANA ADANYA&rdquo; ATAU &ldquo;SEBAGAIMANA TERSEDIA&rdquo;, DAN KAMI SECARA TEGAS
      MELEPASKAN SEMUA JAMINAN DAN KETENTUAN ATAU HAL SERUPA LAINNYA, BAIK SECARA TEGAS MAUPUN TERSIRAT, TERMASUK
      NAMUN TIDAK TERBATAS PADA JAMINAN, KEADAAN YANG DAPAT DIPERJUAL-BELIKAN, ATAU KUALITAS UNTUK TUJUAN TERTENTU,
      KAMI TIDAK MENJAMIN BAHWA KONTEN ATAU PERANTI LUNAK AKURAT, TEPAT WAKTU, TIDAK TERGANGGU, TIDAK MELANGGAR, BEBAS
      VIRUS ATAU BEBAS ERROR, ATAU SETIAP MASALAH TERSEBUT AKAN DIKOREKSI.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >YOUR USE OF THE SERVICES IS AT YOUR SOLE RISK. ALL CONTENT AND SERVICES ARE PROVIDED ON AN &quot;AS IS&quot; OR
      &quot;AS AVAILABLE&quot; BASIS, AND WE EXPRESSLY DISCLAIM ALL WARRANTIES AND CONDITIONS OF ANY KIND WHETHER
      EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR
      PURPOSE. TO THE FULLEST EXTENT AS PERMITTED BY THE PREVAILING LAWS AND REGULATIONS, WE MAKES NO WARRANTY THAT
      THE CONTENT AND SERVICES ARE ACCURATE, TIMELY, UNINTERRUPTED, NON-INFRINGING, VIRUS-FREE OR ERROR-FREE, OR THAT
      ANY SUCH PROBLEMS WILL BE CORRECTED.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span>7.2. </span><span class="c2">Batasan Tanggung Jawab</span
    ><span class="c0"
      >&nbsp;&ndash; ANDA MEMAHAMI DAN MENYETUJUI BAHWA KAMI TIDAK AKAN BERTANGGUNG JAWAB ATAS SETIAP KERUGIAN SECARA
      LANGSUNG, TIDAK LANGSUNG, INSIDENTAL, KHUSUS, KONSEKUENSIAL, ATAU LUAR BIASA, TERMASUK, NAMUN TIDAK TERBATAS
      PADA, KERUGIAN SEBAGAI AKIBAT DARI KEHILANGAN ATAS PRODUK, PENGGUNAAN, DATA ATAU KERUGIAN TIDAK BERWUJUD
      LAINNYA, BAHKAN APABILA KAMI TELAH DIBERITAHU MENGENAI KEMUNGKINAN ATAS KERUGIAN TERSEBUT, YANG TIMBUL DARI
      PENGGUNAAN ATAU KETIDAKMAMPUAN ANDA UNTUK MENGGUNAKAN LAYANAN, KONTEN, ATAU PERANTI LUNAK, ATAU HAL LAINNYA YANG
      BERHUBUNGAN DENGAN LAYANAN, KONTEN, ATAU PERANTI LUNAK. ANDA MENGERTI DAN SETUJU BAHWA PENGGUNAAN LAYANAN ANDA
      DIDASARKAN PADA PEMBEBASAN HAK UNTUK MENUNTUT KAMI ATAU AFILIASI KAMI SECARA LANGSUNG ATAU UNTUK TURUT SERTA
      PADA SEBUAH CLASS ACTION UNTUK SETIAP KERUGIAN YANG TIMBUL DARI PENGGUNAAN LAYANAN OLEH ANDA.</span
    >
  </p>
  <p class="c1">
    <span class="c2 c4">Limitation of Liability</span
    ><span class="c3"
      >&nbsp;&ndash; YOU UNDERSTAND AND AGREE THAT WE WILL NOT BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
      SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES, INCLUDING, BUT NOT LIMITED TO, DAMAGES FOR LOSS OF PRODUCTS, USE,
      DATA OR OTHER INTANGIBLE LOSSES, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITIES OF THOSE DAMAGES, RESULTING
      FROM YOUR USE OF OR INABILITY TO USE THE SERVICES AND/OR CONTENT, OR ANY OTHER MATTER RELATED TO THE SERVICES
      AND/OR CONTENT. YOU UNDERSTAND AND AGREE THAT YOUR USE OF THE SERVICES IS PREDICATED UPON YOUR WAIVER OF ANY
      RIGHT TO SUE US OR OUR AFFILIATES DIRECTLY OR TO PARTICIPATE IN A CLASS ACTION SUIT FOR ANY LOSSES OR DAMAGES
      RESULTING FROM YOUR USE OF THE SERVICES.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >7.3. Anda akan melindungi dan membebaskan Kami, perusahaan induk, anak perusahaan, afiliasi, pelanggan,
      penyedia jasa, pejabat dan karyawan Kami dari segala tanggung jawab, ganti rugi atau biaya (termasuk biaya kuasa
      hukum yang masuk akal) yang timbul berdasarkan (i) segala klaim atau permintaan dari pihak ketiga manapun karena
      atau yang timbul dari akses atau penggunaan Layanan Kami oleh Anda, pelanggaran dari Ketentuan Layanan ini oleh
      Anda, atau pelanggaran yang Anda lakukan terhadap segala hak kekayaan intelektual atau hak apapun yang dimiliki
      oleh orang atau pihak lain.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >You will indemnify and hold Us harmless, Our parents, subsidiaries, affiliates, customers, vendors, officers
      and employees from any liability, damages or cost (including reasonable attorneys&rsquo; cost) arising out of
      (i) any claim or demand made by any third party due to or arising out of Your access to or use of Our Service,
      violation of these Terms of Use by You, or the infringement by You of any intellectual property or other right
      of any person or entity.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c5"><span class="c2">8. Pengakhiran &ndash;</span><span class="c6 c4 c2">&nbsp;Termination</span></p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >8.1. Anda sepakat bahwa dalam hal terjadi pelanggaran oleh Anda terhadap ketentuan dalam Ketentuan Penggunaan
      ini atau terhadap peraturan perundang-undangan yang berlaku, Kami dapat secara sepihak dan tanpa pemberitahuan
      sebelumnya mengakhiri Layanan kepada Anda. Anda sepakat bahwa setiap kerugian materil dan imateril yang timbul
      akibat pengakhiran Layanan tersebut akan sepenuhnya ditanggung oleh Anda.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >You agree that in the event of any breach by You under the terms of these Terms of Use or with the applicable
      laws and regulations, We may unilaterally and without prior notice terminate the Service to You. You agree that
      any material or immaterial loss arising from the such Service termination are entirely borne by You.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >8.2. Untuk tujuan pengakhiran, Anda sepakat untuk mengakhiri ketentuan Pasal 1266 Kitab Undang-Undang Hukum
      Perdata sehingga pengakhiran Layanan akan berlaku efektif tanpa perlu mendapatkan persetujuan atau putusan dari
      pengadilan atau institusi lainnya yang ada di wilayah Republik Indonesia.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >For the purpose of termination, You agree to waive the provisions of Article 1266 of the Indonesian Civil Code
      so that the termination of the Services will be effective without having to obtain any court or other
      institutions approval or judgment within the territory of the Republic of Indonesia.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >8.3. Semua ketentuan dalam Ketentuan Penggunaan ini yang menurut sifatnya harus tetap berlaku setelah
      pengakhiran akan terus berlaku setelah pengakhiran, termasuk, tidak terbatas pada, kekayaan intelektual,
      penafian garansi, ganti rugi, dan ketentuan batasan tanggung jawab.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >All provisions of this Terms of Use which by their nature should survive termination shall survive termination,
      including, without limitation, intellectual property, warranty disclaimers, indemnity and limitations of
      liability provisions.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c2">9. Hukum yang Berlaku dan Penyelesaian Sengketa &ndash;</span
    ><span class="c6 c4 c2">&nbsp;Applicable Law and Dispute Settlement</span>
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span
      >Ketentuan Layanan ini dan kewajiban-kewajiban non-kontraktual lainnya yang timbul dari atau sehubungan dengan
      Ketentuan Layanan ini diatur oleh Hukum Negara Republik Indonesia. Anda setuju bahwa setiap tindakan hukum atau
      perselisihan yang timbul dari penggunaan </span
    ><span class="c3">Layanan Kami akan diselesaikan oleh Pengadilan Negeri Jakarta Selatan.</span>
  </p>
  <p class="c1">
    <span class="c3"
      >These Terms of Use and any other non-contractual obligations arising out of or in connection therewith are
      governed by the laws of the Republic of Indonesia. You agree that any legal action or dispute arising out of the
      use of Our Service will be settled and resolved by the South Jakarta District Court.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c5">
    <span class="c2">10. Tautan dan Pemasaran &ndash;</span
    ><span class="c6 c4 c2">&nbsp;Links and Advertisement</span>
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >Demi kenyamanan Anda, Kami dapat menyertakan hyperlink ke situs atau konten lain di internet yang dimiliki atau
      dioperasikan oleh pihak ketiga. Situs atau konten tertaut tidak berada di bawah kendali Kami dan Kami tidak
      bertanggung jawab atas kesalahan, kelalaian, penundaan, pencemaran nama baik, fitnah, kebohongan, pornografi,
      konten cabul, ketidakakuratan atau materi lain yang terkandung dalam situs atau konten tersebut, atau
      konsekuensi dari mengakses situs web terkait. serta keakuratan informasi, konten, produk atau layanan yang
      ditawarkan oleh, atau praktik informasi yang digunakan oleh situs yang ditautkan ke atau dari Platform. Kami
      menyarankan Anda untuk meninjau kebijakan privasi serta syarat dan ketentuan situs-situs ini sebelum memberikan
      informasi pribadi apa pun.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >For your convenience, We may include hyperlinks to other sites or content on the internet which are owned or
      operated by third parties. The linked site or content is not under Our control and We are not responsible for
      any errors, omissions, delays, defamation, libel, lies, pornography, obscene content, inaccuracies or other
      material contained in the sites or content, or consequences of accessing any related website as well as accuracy
      of the information, content, products or services offered by, or the information practices employed by sites
      linked to or from the Platform. We advise you to review the privacy policies and terms and conditions of these
      sites prior to providing any personal information.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >Kami dapat menampilkan spanduk, applet Java dan/atau hal lain yang diperlukan di Platform untuk tujuan
      periklanan atau iklan produk dan/atau Layanan. Anda mengetahui dan setuju bahwa Anda tidak memiliki hak untuk
      menerima pembayaran, biaya, penggantian dan/atau komisi sehubungan dengan iklan dan/atau materi promosi
      lainnya.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >We may display banners, Java applets and/or other things required in the Platform for advertising purposes or
      advertisement of the products and/or Services. You acknowledge and agree that you do not have the right to
      receive any payment, fees, reimbursement and/or commissions in connection with such advertisements and/or other
      promotional materials.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >Harap diperhatikan bahwa setiap tautan ke situs atau konten lain bukanlah bentuk dukungan atau verifikasi situs
      atau konten tersebut dan Anda setuju bahwa akses Anda ke penggunaan situs atau konten terkait sepenuhnya menjadi
      risiko Anda sendiri. Kami tidak bertanggung jawab atas segala risiko data pribadi dan keamanan data terkait
      akses situs pihak ketiga yang ditautkan ke atau dari Platform. Dalam kasus seperti itu, Kami akan dibebaskan
      dari tanggung jawab atas kerusakan atau kerugian yang terjadi pada akses tautan tersebut, termasuk namun tidak
      terbatas pada kerusakan atau kerugian apa pun yang terkait dengan virus, spyware, malware, worm, trojan,
      kesalahan, bug, atau kerusakan lainnya.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >Please be advised that any link to other sites or content is not a form of endorsement or verification of such
      sites or content and You agree that Your access to the use of linked sites or content is entirely at Your own
      risk. We are not responsible for any risks of personal data and data security for the access of third-party
      sites linked to or from the Platform. In such case, We shall be held free from responsibility for any damage or
      loss occurred upon the access of such links, including but not limited to any damage or loss related to a virus,
      spyware, malware, worm, trojan, fault, bugs, or any other damages.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c5"><span class="c2">11. Bahasa &ndash; </span><span class="c6 c4 c2">Language</span></p>
  <p class="c5"><span class="c6 c2 c7">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >Ketentuan Layanan ini dibuat dalam Bahasa Indonesia dan Bahasa Inggris. Bahasa Inggris menjadi bahasa yang
      berlaku terlepas dari terjemahannya ke Bahasa Indonesia dan dalam hal terdapat perbedaan atau ketidaksesuaian
      antara naskah asli dalam Bahasa Inggris dan Bahasa Indonesia, maka naskah dalam Bahasa Inggris yang
      berlaku.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >This Terms of Service is made in Indonesian and English language. English language shall be the governing
      language despite its translation into Indonesian language and in the event of discrepancies or inconsistencies
      between the original English language text and the Indonesian language text, the English language version will
      prevail.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c5"><span class="c2">12. Lain-lain &ndash; </span><span class="c6 c4 c2">Miscellaneous</span></p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >12.1. Jika ada ketentuan dalam Ketentuan Layanan ini yang dianggap oleh pihak yang berwenang manapun tidak sah
      atau tidak dapat dilaksanakan, ketentuan tersebut akan diubah sehingga ketentuan tersebut dapat dilaksanakan
      sesuai dengan maksud dan tujuan dari ketentuan awal sejauh diperbolehkan oleh peraturan perundang-undangan yan
      gberlaku. Ketentuan-ketentuan lainnya akan tetap sah dan berlaku.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >In the event that any provision of these Terms of Use is deemed by any competent authority to be unenforceable
      or invalid, the relevant provision shall be modified to allow it to be enforced in line with the intention of
      the original text to the fullest extent permitted by the prevailing laws and regulations. The validity and
      enforceability of the remaining provisions of these Terms of Use shall remain.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >12.2. Anda setuju bahwa semua dokumen atau pemberitahuan dapat dikirimkan kepada Anda secara elektronik,
      melalui alamat email Anda yang diberikan pada saat pendaftaran. Oleh karena itu, Anda menyadari dan mengakui
      bahwa Anda bertanggung jawab untuk memperbarui Kami dengan alamat email Anda saat ini dan Kami tidak akan
      bertanggung jawab atas klaim kehilangan atau kerusakan apa pun atas kegagalan untuk menerima
      pemberitahuan.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >You agree that all documents or notices may be delivered to You electronically, through Your e-mail address
      provided upon registration. Accordingly, You recognize and acknowledge that it is your sole responsibility to
      update Us with your current e-mail address and We shall not be liable for any claim of loss or damage for
      failure to receive notices.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >12.3. Anda setuju bahwa semua dokumen, persetujuan, pengakuan, pemberian wewenang, dalam bentuk apa pun
      berdasarkan ketentuan Layanan dapat dilaksanakan secara elektronik, menggunakan tanda tangan elektronik, dan
      Anda menerima keabsahan dan keberlakuannya, kecuali dapat dibuktikan bahwa tanda tangan elektronik yang
      disediakan didasarkan pada tindakan yang melanggar hukum, seperti pemalsuan, penipuan, atau pencurian
      data.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >You agree that all documents, approval, acknowledgement, authorization, in any form whatsoever under the
      provision of Service may be executed electronically, using electronic signatures, and you accept the validity
      and enforceability of which, unless it may be evidenced that the provided electronic signatures are based on
      unlawful action, such as counterfeit, fraud, or data theft.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0"
      >12.4. Untuk pertanyaan tentang Ketentuan Pengguna atau Layanan ini, Anda dapat menghubungi kami melalui email
      ke: cs@kreditpintar.com atau hubungi kami di 021-5059-8882.</span
    >
  </p>
  <p class="c1">
    <span class="c3"
      >For queries regarding the these Terms of User or Services, you can contact us through email to:
      cs@kreditpintar.com or call us at 021-5059-8882.</span
    >
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1">
    <span class="c0">
      12.5. Sehubungan dengan pengaduan Anda atas Layanan yang mungkin Anda sampaikan, Kami tidak mengenakan 
      biaya apapun kepada Anda terkait hal tersebut.
    </span>
  </p>
  <p class="c1">
    <span class="c3">
      In connection with Your complaints about the Services that you may submit, we do not impose any charges 
      on you regarding that matter.
    </span>
  </p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c1"><span class="c0">&nbsp;</span></p>
  <p class="c15">
    <span class="c0 c10">Diperbaharui terakhir pada Januari 2024.</span>
  </p>
  <p class="c15">
    <span class="c3 c10">Last updated on January 2024.</span>
  </p>
  <p class="c1 c9"><span class="c0"></span></p>
</div>`

const styleContentRaw = `
ol {
  margin: 0;
  padding: 0;
}
table td,
table th {
  padding: 0;
}
.c3 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: 'Arial';
  font-style: italic;
}
.c0 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: 'Arial';
  font-style: normal;
}
.c1 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.15;
  orphans: 2;
  widows: 2;
  text-align: left;
}
.c5 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.15;
  orphans: 2;
  widows: 2;
  text-align: center;
}
.c6 {
  color: #000000;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: 'Arial';
}
.c8 {
  background-color: #ffffff;
  padding: 12pt 12pt 0pt;
}
.c4 {
  font-style: italic;
}
.c7 {
  font-style: normal;
}
.c2 {
  font-weight: 700;
}
.c9 {
  height: 11pt;
}
.title {
  padding-top: 0pt;
  color: #000000;
  font-size: 26pt;
  padding-bottom: 3pt;
  font-family: 'Arial';
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
.subtitle {
  padding-top: 0pt;
  color: #666666;
  font-size: 15pt;
  padding-bottom: 16pt;
  font-family: 'Arial';
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
li {
  color: #000000;
  font-size: 11pt;
  font-family: 'Arial';
}
p {
  margin: 0;
  color: #000000;
  font-size: 11pt;
  font-family: 'Arial';
}
h1 {
  padding-top: 20pt;
  color: #000000;
  font-size: 20pt;
  padding-bottom: 6pt;
  font-family: 'Arial';
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
h2 {
  padding-top: 18pt;
  color: #000000;
  font-size: 16pt;
  padding-bottom: 6pt;
  font-family: 'Arial';
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
h3 {
  padding-top: 16pt;
  color: #434343;
  font-size: 14pt;
  padding-bottom: 4pt;
  font-family: 'Arial';
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
h4 {
  padding-top: 14pt;
  color: #666666;
  font-size: 12pt;
  padding-bottom: 4pt;
  font-family: 'Arial';
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
h5 {
  padding-top: 12pt;
  color: #666666;
  font-size: 11pt;
  padding-bottom: 4pt;
  font-family: 'Arial';
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
h6 {
  padding-top: 12pt;
  color: #666666;
  font-size: 11pt;
  padding-bottom: 4pt;
  font-family: 'Arial';
  line-height: 1.15;
  page-break-after: avoid;
  font-style: italic;
  orphans: 2;
  widows: 2;
  text-align: left;
}
`

export const BannerBox = styled.div`
  @media only screen and (max-width: 1000px) {
    .doc-content {
      width: 100%;
      padding: 60pt 14px 0;
      overflow: hidden;
      p,
      span {
        font-size: 14px;
        line-height: 20px;
      }
    }
    .c4 {
      text-align: normal !important;
    }
  }
  @media only screen and (min-width: 1000px) {
    .doc-content {
      {
      width: 75%;
      padding: 20pt 72pt 72pt;
      margin: 80px auto 0;
      p,
      span {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
`
